module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_trouble05-3878dbecb9f27aba9053092b536b51cd.png";